import { matchPath } from 'react-router-dom';
import decodeMatch from './decode-match';

export const matchRoute = ({ url, routes, path = [] }) => {
	for(const routeKey of Object.keys(routes)) {
		const route = routes[routeKey];
		const match = matchPath(url, {
			path: route.path,
			exact: route.exact,
		});
		
		if(match) {
			const routePath = [...path, routeKey];
			const parentMatch = { ...route, key: routePath.join('.'), match: decodeMatch(match) };
			
			if(route.children) {
				const childrenMatch = matchRoute({ url, routes: route.children, path: routePath });
				return childrenMatch ? childrenMatch : parentMatch;
			}
			else {
				return parentMatch;
			}
		}
	}

	return false;
}